<template>
  <a-layout id="components-layout-demo-custom-trigger">
    <!-- sidebar -->
    <sidebar></sidebar>
    <a-layout>
      <a-layout-content :style="{ margin: '16px', padding: '24px', minHeight: '100vh' }">
        <a-row :style="{margin:'5px'}">
          <a-col :span="12">
            <h2>Coupons</h2>
          </a-col>
          <a-col :span="12" :style="{textAlign:'end'}">
            <a-button type="primary" @click="addNewCoupon">Add New</a-button>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="24" :style="{background:'#fff'}">
            <div id="coupons-table">
              <a-table
                  :columns="columns"
                  :loading="loading"
                  :rowKey="record => record.id"
                  :dataSource="coupons"
                  :rowClassName="(record, index) => !record.valid ? 'coupons-expired' : ''"
                  :pagination="false"
              >
                <span slot="name" slot-scope="name,record">
                  <a-tooltip placement="topLeft">
                    <template slot="title">
                      <span>Coupon ID: {{ record.id }}</span>
                    </template>
                    <strong>{{ name }}</strong>
                  </a-tooltip>
                </span>
                <span slot="terms" slot-scope="terms">
                  {{ terms }}
                </span>
                <span slot="redemptions" slot-scope="redemptions">
                  {{ redemptions }}
                </span>
                <span slot="expires" slot-scope="expires">
                  {{ expires }}
                </span>
                <span slot="apply_automatically" slot-scope="apply_automatically">
                  <a-icon type="close-circle" v-if="!apply_automatically" style="color: darkred; font-size: 1.3em;" />
                  <a-icon type="check-circle" v-else style="color: green; font-size: 1.3em;" />
                </span>
                <span slot="actions" slot-scope="actions,record">
                  <a-button type="default" @click="showCouponDetails(record)" shape="circle" style="margin-right: 5px;">
                    <i class="fa fa-search-plus"></i>
                  </a-button>
                  <a-popconfirm
                    title="Are you sure delete this coupon?"
                    placement="top"
                    @confirm="confirmDelete(record.id)"
                    okText="Yes"
                    cancelText="No"
                  >
                    <a-button
                      type="danger"
                      :loading="record.id === deletingId ? true : false"
                      shape="circle"
                    >
                      <i class="fa fa-trash" v-if="record.id != deletingId"></i>
                    </a-button>
                  </a-popconfirm>
                </span>
              </a-table>
            </div>
            <!-- New coupons modal -->
            <a-modal title="Add New Coupon" :maskClosable="false" :footer="null" v-model="addNewCouponVisibility" dialogClass="custom-modal-size">
              <a-form :form="form" @submit.prevent="saveNewCoupon">
                <a-form-item
                  label="Coupon Name"
                  extra="This will appear on customers' receipts and invoices."
                >
                  <a-col span="12"><a-input required v-model="form.name" /></a-col>
                </a-form-item>

                <a-form-item
                  label="ID (Optional)"
                  extra="This ID will be applied by customers as 'Coupon Code'. **An ID may only contain alphanumeric characters in addition to - and _. Length is restricted to 200 characters."
                >
                  <a-col span="12"><a-input v-model="form.id" /></a-col>
                </a-form-item>

                <a-form-item
                  label="Type"
                >
                  <a-col span="24">
                    <a-radio-group v-model="form.off_type" default-value="a" button-style="solid">
                      <a-radio-button value="percentage">
                        Percentage discount
                      </a-radio-button>
                      <a-radio-button value="amount">
                        Fixed amount discount
                      </a-radio-button>
                    </a-radio-group>
                  </a-col>
                  <a-col span="24" style="margin-top: 10px;">
                    <div v-if="form.off_type === 'amount'">
                      <p style="margin-bottom: 0; padding-bottom: 0; line-height: 20px;">
                        <strong>Discount Amount</strong>
                      </p>
                      <a-input-number
                        :default-value="0"
                        :formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                        :parser="value => value.replace(/\$\s?|(,*)/g, '')"
                        @change="onChangeAmount"
                        :style="{ width: '150px' }"
                      />
                    </div>
                    <div v-if="form.off_type === 'percentage'">
                      <p style="margin-bottom: 0; padding-bottom: 0; line-height: 20px;">
                        <strong>Percentage off</strong>
                      </p>
                      <a-input-number
                        :min="0"
                        :max="100"
                        :formatter="value => `${value}%`"
                        :parser="value => value.replace('%', '')"
                        @change="onChangePercentage"
                        :style="{ width: '150px' }"
                      />
                    </div>
                  </a-col>
                </a-form-item>

                <a-form-item
                  label="Duration"
                  extra="For subscriptions, this determines how long this coupon will apply once redeemed. One-off invoices accept both 'once' and 'forever' coupons."
                >
                  <a-col span="12">
                    <a-select v-model="form.duration" style="width: 190px">
                      <a-select-option value="forever">
                        Forever
                      </a-select-option>
                      <a-select-option value="once">
                        Once
                      </a-select-option>
                      <a-select-option value="repeating">
                        Multiple Months
                      </a-select-option>
                    </a-select>
                  </a-col>
                  <a-col span="12" v-if="form.duration === 'repeating'">
                    <span style="margin-right: 10px;"><strong>No. of months</strong></span>
                    <a-input-number
                      v-model="form.duration_in_months"
                      :min="1"
                      :max="120" />
                  </a-col>
                </a-form-item>

                <a-form-item
                  label="Redemption Limits"
                >
                  <div>
                    <a-checkbox v-model="form.has_redeem_by" @change="onChangeRedeemBy">
                      Limit the date range when customers can redeem this coupon
                    </a-checkbox>
                    <div style="padding-left: 30px;" v-if="form.has_redeem_by">
                      <a-checkbox v-model="form.has_redeem_from" @change="onChangeRedeemFrom">
                        Has redeem from date?
                      </a-checkbox>
                      <div v-if="form.has_redeem_from">
                        <div style="font-weight: bold;">Redeem From</div>
                        <div>
                          <span style="margin-right: 10px;">
                            <a-date-picker
                              :disabled-date="disabledDate"
                              @change="onChangeRedeemFromDate"
                            />
                          </span>
                          <a-time-picker use12-hours format="HH:mm A" @change="onChangeRedeemFromTime" />
                        </div>
                      </div>
                    </div>
                    <div style="padding-left: 30px;" v-if="form.has_redeem_by">
                      <div style="font-weight: bold;">Redeem By</div>
                      <div>
                        <span style="margin-right: 10px; width: 250px">
                          <a-date-picker
                            :disabled-date="disabledDate"
                            @change="onChangeDate"
                          />
                        </span>
                        <a-time-picker use12-hours format="HH:mm A" @change="onChangeTime" />
                      </div>
                    </div>
                    <div style="padding-left: 30px;" v-if="form.has_redeem_by">
                      <div style="font-weight: bold;">Redeem Timezone</div>
                      <div>
                        <a-select v-model="timezone" style="width: 330px">
                          <a-select-option
                              v-for="timezone, index in timezones"
                              :key="index"
                              :value="timezone"
                          >
                            {{ timezone }}
                          </a-select-option>
                        </a-select>
                      </div>
                    </div>
                  </div>
                  <div>
                    <a-checkbox
                        v-model="form.has_max_redemptions_limit"
                        @change="onChangeHasMaxRedemptionsLimit"
                    >
                      Limit the total number of times this coupon can be redeemed
                    </a-checkbox>
                    <div style="padding-left: 30px;" v-if="form.has_max_redemptions_limit">
                      <a-input-number v-model="form.max_redemptions" :min="1" />
                      <span style="margin-left: 10px;">Maximum no. of times</span>
                    </div>
                  </div>
                </a-form-item>

                <a-form-item
                  extra="This created coupon code will be automatically applied & displayed in 'coupon code' section of billing while subscribing to a premium plan."
                >
                  <a-switch checked-children="Yes"
                    un-checked-children="No"
                    :default-checked="form.coupon_apply_automatically"
                    @change="couponCodeApplyAutomaticallyToggle"
                  />
                    <label style="margin-left: 10px;"><strong>Apply Automatically?</strong></label>
                </a-form-item>

                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button type="primary" size="large" html-type="submit" :loading="submitting">Save Coupon</a-button>
                  <a-button style="margin-left: 10px;" size="large" type="default" @click.prevent="addNewCouponVisibility = false;">Cancel</a-button>
                </a-form-item>
              </a-form>
            </a-modal>

            <!-- Preview coupon modal -->
            <a-modal title="Coupon Details" v-model="couponPreviewVisibility" :footer="null">
              <table width="100%" style="border-collapse: collapse; border: none;">
                <tbody style="border: none;">
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Coupon Name</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      {{ previewCoupon.name }}
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Coupon Code</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      {{ previewCoupon.id }}
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Coupon Terms</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      {{ previewCoupon.terms }}
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Redemptions</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      <a-tag color="cyan">
                        {{ previewCoupon.redemptions }}
                      </a-tag>
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Redeem From</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      <a-tag style="font-size: 16px;">
                        {{ previewCoupon.redeem_from }}
                      </a-tag>
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 5px;">
                      <strong>Redeem By</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 5px;">
                      <a-tag style="font-size: 16px;">
                        {{ previewCoupon.expires }}
                      </a-tag>
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">

                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;"
                        v-if="previewCoupon.expires !== '--' && previewCoupon.redeem_from !== '--'"
                    >
                      <small style="color: red; font-size: 10px; font-weight: 200;">
                        ** Dates are in Asia/Dhaka(DB) timezone
                      </small>
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Has Expired?</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      <i class="fa fa-check-circle"
                        style="color: green; font-size: 20px;"
                        v-if="!previewCoupon.valid"
                      ></i>
                      <i class="fa fa-times-circle"
                        style="color: red; font-size: 20px;"
                        v-else
                      ></i>
                    </td>
                  </tr>
                  <tr style="border: none;">
                    <td style="border: none; width: 35%; padding-bottom: 15px;">
                      <strong>Apply Automatically?</strong>
                    </td>
                    <td style="border: none; width: 65%; padding-bottom: 15px;">
                      <i class="fa fa-check-circle"
                        style="color: green; font-size: 20px;"
                        v-if="previewCoupon.apply_automatically"
                      ></i>
                      <i class="fa fa-times-circle"
                        style="color: red; font-size: 20px;"
                        v-else
                      ></i>
                    </td>
                  </tr>
                </tbody>
              </table>
            </a-modal>
          </a-col>
        </a-row>
      </a-layout-content>
    </a-layout>
  </a-layout>
</template>

<script>
  import Sidebar from "@/components/Sidebar.vue";
  import Api from "@/services/Api";
  import moment from 'moment';
  import timezones from './../../services/timezones';

  const columns = [
    {
      title: "Coupon",
      dataIndex: "name",
      scopedSlots: { customRender: "name" }
    },
    {
      title: "Terms",
      dataIndex: "terms",
      scopedSlots: { customRender: "terms" }
    },
    {
      title: "Redemptions",
      dataIndex: "redemptions",
      scopedSlots: { customRender: "redemptions" }
    },
    {
      title: "Expires (BD Timezone)",
      dataIndex: "expires",
      scopedSlots: { customRender: "expires" }
    },
    {
      title: "Apply Automatically?",
      dataIndex: "apply_automatically",
      scopedSlots: { customRender: "apply_automatically" }
    },
    {
      title: "Actions",
      dataIndex: "actions",
      scopedSlots: { customRender: "actions" }
    }
  ];

  export default {
    components: {
      Sidebar
    },
    data() {
      return {
        addNewCouponVisibility: false,
        couponPreviewVisibility: false,
        previewCoupon: {},
        form: this.resetFormData(),
        columns,
        coupons: [],
        loading: false,
        deletingId: null,
        submitting: false,
        timezones: [],
        timezone: 'Asia/Dhaka'
      };
    },
    methods: {
      resetFormData() {
        return {
          name: '',
          id: '',
          amount_off: null,
          percent_off: null,
          off_type: 'percentage',
          duration_in_months: null,
          duration: 'forever',
          max_redemptions: null,
          has_max_redemptions_limit: false,
          has_redeem_by: false,
          redeem_by_time: null,
          redeem_by_date: null,
          has_redeem_from: false,
          redeem_from_time: null,
          redeem_from_date: null,
          coupon_apply_automatically: false
        };
      },

      showCouponDetails(coupon) {
        this.previewCoupon = coupon;
        this.couponPreviewVisibility = true;
      },

      addNewCoupon() {
        this.form = this.resetFormData();
        this.timezone = 'Asia/Dhaka';
        this.addNewCouponVisibility = true;
        this.submitting = false;
      },

      saveNewCoupon() {
        const payload = this.generatePayload();
        this.submitting = true;
        Api.post('coupons', payload)
          .then((res) => {
            this.submitting = false;
            this.addNewCouponVisibility = false;
            this.coupons.unshift(res.data.coupon);
            this.$notification.success({
              message: 'Coupon created.',
              description: res.data.message
            });
          })
          .catch(() => {
            this.submitting = false;
            this.$notification.error({
              message: 'Operation Failed!',
              description: "Something went wrong while submitting form. Check your inputs & retry again. Also, check response in network tab for more details."
            });
            return;
          });
      },

      confirmDelete(couponId) {
        this.deletingId = couponId;
        Api.delete(`coupons/${couponId}`)
          .then(res => {
            this.coupons = this.coupons.filter(coupon => coupon.id !== couponId);
            this.deletingId = null;
            this.$notification.success({
              message: res.data.message,
              description:
                'Coupon has removed from both weMail DB and stripe service.',
            });
            this.loadCoupons();
          })
          .catch(err => {
            this.deletingId = null;
            this.$notification.error({
              message: 'Operation Failed!',
              description: err.response.data.message
            });
          })
      },

      generatePayload() {
        const {
          id, name, duration, coupon_apply_automatically, duration_in_months,
          off_type, amount_off, percent_off, has_redeem_by, redeem_by_date,
          redeem_by_time, max_redemptions, has_redeem_from, redeem_from_date,
          redeem_from_time
        } = this.form;
        const payload = { name, duration, coupon_apply_automatically };
        if (id) payload.id = id;
        if (duration === 'repeating') payload.duration_in_months = duration_in_months;
        if (off_type === 'percentage') {
          payload.percent_off = percent_off;
        } else {
          payload.amount_off = amount_off;
        }
        if (has_redeem_by) {
          payload.redeem_by = `${redeem_by_date} ${redeem_by_time}:00`;
          if (has_redeem_from) {
            payload.redeem_from = `${redeem_from_date} ${redeem_from_time}:00`;
          }
          payload.redeem_by_tz = this.timezone;
        }
        if (max_redemptions) payload.max_redemptions = max_redemptions;

        return payload;
      },

      onChangePercentage(value) {
        this.form.percent_off = value;
      },

      onChangeAmount(value) {
        this.form.amount_off = value;
      },

      couponCodeApplyAutomaticallyToggle(value) {
        this.form.coupon_apply_automatically = value;
      },

      disabledDate(current) {
        return current && current < moment().subtract(1, 'days').endOf('day');
      },

      onChangeDate(date, dateString) {
        this.form.redeem_by_date = dateString;
      },

      onChangeTime(time) {
        this.form.redeem_by_time = time.format('HH:mm');
      },

      onChangeRedeemBy() {
        this.form.redeem_by_time = null;
        this.form.redeem_by_date = null;
      },

      onChangeRedeemFromDate(date, dateString, type) {
        this.form.redeem_from_date = dateString;
      },

      onChangeRedeemFromTime(time, type) {
        this.form.redeem_from_time = time.format('HH:mm');
      },

      onChangeRedeemFrom() {
        this.form.redeem_from_time = null;
        this.form.redeem_from_date = null;
      },

      onChangeHasMaxRedemptionsLimit() {
        this.form.max_redemptions = null;
      },

      loadCoupons() {
        this.loading = true;
        Api.get('coupons')
        .then(res => {
          this.loading = false;
          this.coupons = res.data.coupons;
        })
        .catch(err => {
          this.loading = false;
          this.$notification.error({
            message: 'Server error.',
            description: err.response.data.message,
          });
        });
      }
    },

    created() {
      this.timezones = timezones.sort();
      this.loadCoupons();
    }
  };
</script>

<style lang="scss">
  #coupons-table .coupons-expired {
    color: #c0bfbf;
  }

  @media screen and (min-width: 767px) {
    #coupons-table {
      th[key="actions"] {
        width: 11%;
      }
      th[key="apply_automatically"] {
        width: 16%;
      }
      th[key="expires"] {
        width: 18%;
      }
      th[key="redemptions"] {
        width: 10%;
      }
      th[key="terms"] {
        width: 20%;
      }
      th[key="name"] {
        width: 25%;
      }
      .ant-table-tbody tr td:nth-child(5) {
        text-align: center;
      }
      .ant-table-tbody tr td:nth-child(3) {
        text-align: center;
      }
    }

    @media screen and (min-width: 800px) {
      .custom-modal-size .ant-modal-content {
        width: 650px;
      }
    }

  }

</style>